import React from 'react'

export default function Sample() {
  return (
    <div>This is a sample page</div>
  )
}
